import { TextRichText } from '$providers/Text';
import cn from 'classnames';
import { HTMLAttributes, useEffect, useRef, useState } from 'react';

import { IAccordion } from './';

export function AccordionItem(props: IAccordion & HTMLAttributes<HTMLElement>) {
  const { className, content, richText, title, index, active, onClick } = props;

  const contentElement = useRef(null);

  const [height, setHeight] = useState('0px');
  const [opacity, setOpacity] = useState('0');

  useEffect(() => {
    setHeight(active ? `${contentElement.current.scrollHeight}px` : '0px');
    setOpacity(active ? `1` : '0');
  }, [active]);

  return (
    <div
      key={index}
      onClick={onClick}
      className={cn(className, 'border-b-[1px] border-grey-40')}
    >
      <div
        className={cn(
          'py-6 flex justify-between bg-no-repeat bg-right cursor-pointer font-bold',
          active ? 'chevron-open text-50' : 'chevron-closed text-grey-100',
        )}
      >
        <h4 className={cn('style-heading-xxxs pr-7 md:pr-0')}>{title}</h4>
      </div>
      <div
        ref={contentElement}
        style={{ height: height, opacity: opacity }}
        className={cn(
          'overflow-hidden transition-all duration-500 style-body-m',
        )}
      >
        {/*<p className={cn('pb-6')}>{content}</p>*/}
        {!richText && content && (
          <p className={cn('mb-4 md:mb-8 text-grey-80')}>{content}</p>
        )}
        {richText && (
          <div className={cn('mb-4 md:mb-8 text-grey-80')}>
            <TextRichText json={richText?.json} />
          </div>
        )}
      </div>
    </div>
  );
}
